<template>
	<div id="app">
		<Offline @changed="offlineDetector"></Offline>
		<Alert></Alert>

		<Layout />
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { EventBus } from '../event-bus.js';
import Alert from "@/new/components/Alerts/Alert.vue";
import Offline from "@/new/components/Alerts/Offline.vue";
import Layout from "@/new/views/Layout.vue";

export default {
	name: "App",
	
	components: {
		Layout,
		Alert,
		Offline,
	},

    computed : {
		isLoggedIn: function() { return this.$store.getters.isLoggedIn },
		isLoginedNow: function() { return this.$store.getters.isLoginedNow }
	},
	
	mounted() {
		document.title = "uFinance";

		this.$store.commit('initEvents');

		this.loadSystem();

		if(this.isLoggedIn) {
			axios.get('/user').then(({data}) => {
				this.$store.state.user = data.data;
				this.$ga.set({userId: data.data.id, language: this.$store.state.language});
			});
		}
	},

	methods: {
        ...mapActions(['loadSystem']),

		offlineDetector(status) {
			if(! status) {
				EventBus.$emit('show-alert', 'Отсутсвует подключение к интернету.', 'error');
			}
		},
		initSteps() {
			window.tour.addSteps([{
				element: ".card-selector > .card:first-child",
				title: "Ваши счета",
				content: "Вы находитесь на главной странице, тут будут размещены ваши счета которые вы включите для отображения в настройках. Вы в любой момент можете их скрыть.",
				placement: "right",
			}, {
				element: ".stats-block.balance",
				title: "Баланс",
				content: "Здесь будет отображен ваш сумарный баланс, он рассчитан из счетов, которые отображены сверху.",
				placement: "right",
			}, {
				element: ".today-spends",
				title: "Траты за текущий день",
				content: "Здесь вы будете видеть ваши траты за текущий день. Так же если у вас есть планы по основному бюджету, вы увидите ваш доступный лимит на текущий день, и прогресс трат.",
				placement: "left",
			}, {
				element: ".statement",
				title: "Операции",
				content: "Здесь вы будете видеть ваши последние операции которые вы сделали или добавили.",
				placement: "top",
			}]);

			this.tour.inited = true;
		},
		initTour() {
			if(! this.tour.inited) {
				this.initSteps();
			}

			window.tour.start();
		},
	},
};
</script>


<style lang="scss">
.sticky-top-block {
	@media (min-width: 767px) {
    	position: fixed;
	}
}

#page-content-wrapper {
    width: 100vw;
    display: flex;
    flex-direction: column;

    background: #FCFDFF;
	overflow-y: auto;
	overscroll-behavior: contain;
	
	@media (max-width: 767px) {
		padding-bottom: 60px;
	}

	bottom: env(safe-area-inset-bottom);

    // /* iphone X , XS, 11 Pro */
    // @media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3) { bottom: 80px; }

    // /* iphone XR, 11 */
    // @media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 2) { bottom: 80px; }

    // /* iphone XS Max, 11 Pro Max */
    // @media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 3) { bottom: 80px; }
}

.lds-roller {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
	
	div {
		animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		transform-origin: 40px 40px;

		&:after {
			content: " ";
			display: block;
			position: absolute;
			width: 7px;
			height: 7px;
			border-radius: 50%;
			background: #cef;
			margin: -4px 0 0 -4px;
		}
		
		&:nth-child(1) {
			animation-delay: -0.036s;

			&:after {
				top: 63px;
				left: 63px;
			}
		}

		&:nth-child(2) {
			animation-delay: -0.072s;

			&:after {
				top: 68px;
				left: 56px;
			}
		}
		
		&:nth-child(3) {
			animation-delay: -0.108s;

			&:after {
				top: 71px;
				left: 48px;
			}
		}

		&:nth-child(4) {
			animation-delay: -0.144s;

			&:after {
				top: 72px;
				left: 40px;
			}
		}

		&:nth-child(5) {
			animation-delay: -0.18s;

			&:after {
				top: 71px;
				left: 32px;
			}
		}

		&:nth-child(6) {
			animation-delay: -0.216s;

			&:after {
				top: 68px;
				left: 24px;
			}
		}
		
		&:nth-child(7) {
			animation-delay: -0.252s;

			&:after {
				top: 63px;
				left: 17px;
			}
		}
		
		&:nth-child(8) {
			animation-delay: -0.288s;

			&:after {
				top: 56px;
				left: 12px;
			}
		}
	}
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
